export const UserActionTypes = {
    SET_MONGO_USER: 'user/SET_MONGO_USER',
    UPDATE_MONGO_USER: 'user/UPDATE_MONGO_USER',
    CLEAR_USER: 'user/CLEAR_USER',
    SET_LOADING_MONGO_USER: 'user/SET_LOADING_MONGO_USER',
    SET_LOADING_LOGOUT: 'user/SET_LOADING_LOGOUT',
    SET_LOADING_SIGN_IN: 'user/SET_LOADING_SIGN_IN',
    SET_IS_RECRUITER_MODE: 'user/SET_IS_RECRUITER_MODE',
    SET_PROFILE_USER: 'user/SET_PROFILE_USER',
    SET_LOADING_PROFILE_USER: 'user/SET_LOADING_PROFILE_USER',
    SET_PROFILE_USER_NOT_FOUND: 'user/SET_PROFILE_USER_NOT_FOUND',
    SET_USER_STATS: 'user/SET_USER_STATS',
    SET_LOADING_USER_STATS: 'user/SET_LOADING_USER_STATS',
}